module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "goods-company-summary-excel",
    on: {
      "click": _vm.excelExport
    }
  }), _vm._v(" "), _c('tips-select', {
    attrs: {
      "tipsFont": _vm.contentFont,
      "btnFont": _vm.contentBtnFont
    },
    on: {
      "tipStatus": _vm.onContentSelect
    },
    model: {
      value: (_vm.contentShow),
      callback: function($$v) {
        _vm.contentShow = $$v
      },
      expression: "contentShow"
    }
  }), _vm._v(" "), _c('tips-select', {
    attrs: {
      "tipsFont": _vm.styleFont,
      "btnFont": _vm.styleBtnFont
    },
    on: {
      "tipStatus": _vm.onStyleSelect
    },
    model: {
      value: (_vm.styleShow),
      callback: function($$v) {
        _vm.styleShow = $$v
      },
      expression: "styleShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d59ffc2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExcelExport.vue
// module id = 540
// module chunks = 1